import React from "react"
import SuTransactionInnerListUI from "../../../components/superUser/transaction/SuTransactionInnerListUI"
import IconButtonUI from "../../../widgets/action/IconButtonUI"
import LRTableActionsUI from "../../../widgets/layout/LRTableActionsUI"
import { Link } from "react-router-dom"
import SuperUserTxnPageUI from "../../../templates/SuperUserTxnPageUI"


const DailytrasactionListPageUI = ({
    context, response, errorList, creditSum, debitSum, txnsList, onRefreshClick, details, onDetailsClick, currentDate, previousDate, nextDate
    , onCopyToClipboard, copyToClipboardText, onPreviousClick, onNextClick, onDownloadExcelReport
}) =>
    <SuperUserTxnPageUI context={context} className='pg_su_txn_l' topnav='transactions'
        headerText='Daily transactions' centered={!txnsList && !errorList}
        page='daily' dimension='w768'
    >
        {
            <div className='txns'>
                <div className='g_flex_h g_m_top_25 g_m_bottom_25'>
                    <Link to='#' onClick={onDetailsClick}>Details</Link>
                </div>
            </div>
        }

        {
            <LRTableActionsUI location='top'
                left={
                    <span className='g_flex_left g_flex_h'>
                        <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                        <IconButtonUI icon='icon-download' onClick={onDownloadExcelReport} label='Download Transaction Excel' />
                        <span className='g_m_left_100 g_large'><b>Daily Transactions {currentDate}</b></span>
                    </span>
                }
                right={
                    <span>
                        <Link to="#" onClick={onPreviousClick}>Previous</Link>
                        <span className='g_m_left_100' />
                        <Link to="#" onClick={onNextClick}>Next</Link>
                    </span>
                }
            />
        }

        {
            txnsList &&
            <div>
                <SuTransactionInnerListUI context={context} txnList={txnsList} details={details} caller='dailyTxnList'
                    creditSum={creditSum} debitSum={debitSum} onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                />
            </div>
        }
    </SuperUserTxnPageUI>

export default DailytrasactionListPageUI